<div id="scroll-container">
    <div class="w-100-p table-wrapper" *ngIf="dataSource">
        <ng-container *ngIf="!(isFetchingModuleEventAttendances$ | async) || (filteredModuleEventAttendances$ | async)?.length; else shimmer">
            <mat-table #table [dataSource]="dataSource" matSort>
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="firstName">{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let moduleEventAttendance">
                        <div fxLayout="row" fxLayoutAlign="start center" class="name-cell">
                            <div class="relative" #avatarCell>
                                <img
                                    class="avatar"
                                    *ngIf="moduleEventAttendance.participant.profilePicture; else initials"
                                    [alt]="moduleEventAttendance.participant.fullName"
                                    [src]="moduleEventAttendance.participant.profilePicture.thumbUrl"
                                />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">
                                        {{ moduleEventAttendance.participant.fullName | initials }}
                                    </div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="moduleEventAttendance.participant.isOnline"> </ng-template>
                            </div>
                            <p class="text-truncate font-semibold ml-12" [tooltipIfTruncated]="moduleEventAttendance.participant.fullName">
                                {{ moduleEventAttendance.participant.fullName }}
                            </p>
                        </div>
                    </mat-cell>
                </ng-container>

                <!-- Taken by Column -->
                <ng-container matColumnDef="updatedBy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.LABEL.MARKED_BY' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let moduleEventAttendance">
                        <p
                            class="text-truncate font-semibold"
                            [tooltipIfTruncated]="moduleEventAttendance.updatedBy?.fullName"
                        >
                            {{ moduleEventAttendance.updatedBy?.fullName || '-' }}
                        </p>
                    </mat-cell>
                </ng-container>

                <!-- Attendance Column -->
                <ng-container matColumnDef="attendance">
                    <mat-header-cell *matHeaderCellDef>
                        {{ 'PAGE.MODULE_DETAILS.TAB.ATTENDANCE.TITLE' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let moduleEventAttendance">
                        <div class="attendance-status-buttons">
                            <button
                                *ngFor="let attendanceStatus of attendanceStatuses"
                                type="button"
                                mat-stroked-button
                                class="attendance-status-btn mat-elevation-z0"
                                [class.attendance-status-btn-green]="
                                    moduleEventAttendance.status === attendanceStatus.value && attendanceStatus.selectedColor === 'green'
                                "
                                [class.attendance-status-btn-red]="
                                    moduleEventAttendance.status === attendanceStatus.value && attendanceStatus.selectedColor === 'red'
                                "
                                (click)="updateModuleEventAttendanceStatus(moduleEventAttendance, attendanceStatus)"
                            >
                                {{ attendanceStatus.translationLabel | translate }}
                            </button>
                        </div>
                    </mat-cell>
                </ng-container>

                <!-- Note Column -->
                <ng-container matColumnDef="note">
                    <mat-header-cell *matHeaderCellDef>{{ 'FORM.EVENT.FIELD.DESCRIPTION' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let moduleEventAttendance">
                        <mat-form-field #commentInput appearance="outline" floatLabel="never" class="module-event-attendance-comment w-100-p">
                            <input
                                matInput
                                (ngModelChange)="markCommentDirty(commentInput)"
                                (blur)="onCommentSave(moduleEventAttendance, commentInput)"
                                [(ngModel)]="moduleEventAttendance.comment"
                                [placeholder]="'EVENT.ATTENDANCE.NOTE_OPTIONAL' | translate"
                            />
                            <div class="module-event-attendance-comment-icons">
                                <mat-icon
                                    class="clear mr-4"
                                    (mousedown)="$event.preventDefault()"
                                    (click)="moduleEventAttendance.comment = ''; markCommentDirty(commentInput); onCommentSave(moduleEventAttendance, commentInput); $event.stopPropagation()"
                                >
                                    close
                                </mat-icon>
                                <mat-icon
                                    class="save"
                                    (mousedown)="$event.preventDefault()"
                                    (click)="onCommentSave(moduleEventAttendance, commentInput); $event.stopPropagation()"
                                >
                                    checkmark
                                </mat-icon>
                            </div>
                        </mat-form-field>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let user; columns: displayedColumns" class="user"> </mat-row>
            </mat-table>

            <div
                fxLayout="row"
                fxLayoutAlign="center center"
                *ngIf="!(filteredModuleEventAttendances$ | async)?.length && !(isFetchingModuleEventAttendances$ | async)"
            >
                <div class="py-48" fxLayout="column" fxLayoutAlign="center center">
                    <mat-icon svgIcon="empty"></mat-icon>
                    <h3 class="mt-12">{{ 'EVENT.ATTENDANCE.NO_PARTICIPANTS' | translate }}</h3>
                </div>
            </div>
        </ng-container>

        <ng-template #shimmer>
            <div class="attendance-shimmer-container">
                <div class="attendance-shimmer-row" *ngFor="let item of shimmerRows" fxLayout="row" fxLayoutAlign="start center">
                    <div class="attendance-shimmer-avatar animate mr-12"></div>
                    <div class="attendance-shimmer-line animate name-line mr-24"></div>
                    <div class="attendance-shimmer-line animate taken-by-line mr-24"></div>
                    <div class="attendance-shimmer-line animate attendance-line mr-24"></div>
                    <div class="attendance-shimmer-line animate note-line"></div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
